import { photoPosition, photoSide } from '@/types/uiPhoto.types'
import { ESTYLE_BULLET } from '~/components/UiPhotoWithDescription/UiPhotoWithDescription.types'

export default function () {
  const { t } = useI18n()
  
  const uiPhotoData = () => {
    return {
      desktopPhotoPosition: photoPosition.RIGHT,
      photoDesktop: [{
        url: t('wellbeingSale.commandCenter.photo'),
        public_id: '',
      }],
      photoMobile: [{
        url: t('wellbeingSale.commandCenter.photo'),
        public_id: '',
      }],
      photoSide: photoSide.RIGHT,
      styleBullet: ESTYLE_BULLET.CHECKER,
      descriptionSize: 'big',
      description: {
        content: [
          {
            nodeType: 'paragraph',
            content: [
              {
                value: t('wellbeingSale.commandCenter.paragraph1'),
              },
            ],
          },
          {
            nodeType: 'paragraph',
            content: [
              {
                value: t('wellbeingSale.commandCenter.paragraph2'),
              },
            ],
          },
          {
            nodeType: 'unordered-list',
            content: [
              {
                content: [
                  {
                    content: [
                      {
                        value: t('wellbeingSale.commandCenter.bullet1'),
                      },
                    ],
                  },
                ],
              },
              {
                content: [
                  {
                    content: [
                      {
                        value: t('wellbeingSale.commandCenter.bullet2'),
                      },
                    ],
                  },
                ],
              },
              {
                content: [
                  {
                    content: [
                      {
                        value: t('wellbeingSale.commandCenter.bullet3'),
                      },
                    ],
                  },
                ],
              },
              {
                content: [
                  {
                    content: [
                      {
                        value: t('wellbeingSale.commandCenter.bullet4'),
                      },
                    ],
                  },
                ],
              },
            ],
          },
        ],
      },
    }
  }

  return {
    uiPhotoData,
  }
}
